//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$NewsletterController_getStats,
  Response$NewsletterController_getStats$Status$200,
  ResponseContentType$NewsletterController_getStats,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useNewsletterController_getStats = (options: {
  params: Params$NewsletterController_getStats['parameter'];
  config?: QueryOptions<
    Response$NewsletterController_getStats$Status$200[ResponseContentType$NewsletterController_getStats]
  >;
}) =>
  useApiClient<
    Params$NewsletterController_getStats,
    Response$NewsletterController_getStats$Status$200[ResponseContentType$NewsletterController_getStats]
  >({
    method: 'NewsletterController_getStats',
    params: { parameter: options.params },
    config: options.config,
  });
